export default "__VITE_ASSET__B$4Jwxfg__"